const headerGroupButtonsHandler = (
  dispatch,
  dispatchFC,
  openArr,
  swtName,
  name,
  id,
  location,
  specificLocation
) => {
  function updateHash(newParams) {

    const scrollPosition = window.scrollY;

    const currentHash = window.location.hash.replace("#", "");
    const params = new URLSearchParams(currentHash);

    Object.keys(newParams).forEach(key => {
      if (newParams[key]) {
        params.set(key, newParams[key]);
      } else {
        params.delete(key);
      }
    });

    window.history.pushState({}, "", `#${params.toString()}`);


    window.scrollTo(0, scrollPosition);
  }

  switch (name) {
    case "expand": {
      if (openArr[id]) {

        dispatch(
          dispatchFC({
            swtName,
            openSpecificLocationIdx: id,
            index: id,
            status: false,
          })
        );

        if (specificLocation) {

          updateHash({ specificLocation: "" });
          sessionStorage.removeItem("specificLocationId");
        } else {
          updateHash({ location: "" });
          sessionStorage.removeItem("locationId");
          updateHash({ specificLocation: "" });
          sessionStorage.removeItem("specificLocationId");
        }
      } else {

        openArr.forEach((_, index) =>
          index === id
            ? dispatch(
                dispatchFC({
                  swtName,
                  openSpecificLocationIdx: id,
                  index: id,
                  status: true,
                })
              )
            : dispatch(
                dispatchFC({
                  swtName,
                  openSpecificLocationIdx: index,
                  index,
                  status: false,
                })
              )
        );

        if (specificLocation) {

          updateHash({ specificLocation });
          sessionStorage.setItem("specificLocationId", specificLocation);
        } else {
          updateHash({ location });
          sessionStorage.setItem("locationId", location);
        }
      }
      break;
    }
    case "weather": {
      console.log(name, id);
      break;
    }
    case "upload": {
      console.log(name, id);
      break;
    }
    case "view": {
      console.log(name, id);
      break;
    }
    default:
      break;
  }
};

export default headerGroupButtonsHandler;
